<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <v-card class="container">
        <v-toolbar
          color="#FF9900"
          class="white--text"
        >
          <template v-slot:extension>
            <v-toolbar-title>Client Settings</v-toolbar-title>
          </template>
          <v-spacer />
        </v-toolbar>
        <p />
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <h4>Change name</h4>
            <v-layout
              row
              wrap
              align-end
              justify-end
            >
              <v-flex xs10>
                <v-text-field
                  v-if="client"
                  v-model="client.name"
                  :error-messages="form.name.errors"
                  :messages="form.name.messages"
                  label="Full name"
                  jest="full_name"
                  required
                />
              </v-flex>
              <v-flex
                xs2
                class="text-xs-right"
              >
                <v-btn
                  fab
                  flat
                  @click="_storeName({name: client.name })"
                >
                  <v-icon>check</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <p />
          </v-flex>
          <v-flex xs12>
            <v-layout
              row
              align-end
              justify-end
            >
              <v-flex xs10>
                <h4>Generate API key</h4>
                <v-text-field
                  v-if="client"
                  v-model="client.api_key"
                  :error-messages="form.apiKey.errors"
                  :messages="form.apiKey.messages"
                  :value="client.api_key"
                  label="API Key"
                  required
                />
              </v-flex>
              <v-flex
                xs2
                class="text-xs-right"
              >
                <v-btn
                  fab
                  flat
                  @click="_generateApiKey"
                >
                  <v-icon>restore_page</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <p />
          </v-flex>
          <v-flex xs12>
            <v-layout
              row
              wrap
              align-end
              justify-end
            >
              <v-flex xs8>
                <h4>Import link</h4>
                <v-text-field
                  v-model="form.linkMasterPassword.value"
                  label="Current master password"
                  type="password"
                  :error-messages="form.linkMasterPassword.errors"
                  :messages="form.linkMasterPassword.messages"
                  required
                />
              </v-flex>
              <v-flex
                xs4
                class="text-xs-right"
              >
                <v-btn
                  outline
                  @click="_generateImportLink({master_password: form.linkMasterPassword.value })"
                >
                  Generate
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <p />
            <h4>Change master password</h4>
            <p />
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <h5>Current master password</h5>
                <v-text-field
                  v-model="form.masterPassword.value"
                  :error-messages="form.masterPassword.errors"
                  :messages="form.masterPassword.messages"
                  type="password"
                  label="Current password"
                  required
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <p />
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <h5>Set new master password</h5>
                <v-text-field
                  v-model="form.newMasterPassword.value"
                  :error-messages="form.newMasterPassword.repeatErrors"
                  type="password"
                  label="Master password"
                  required
                />
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <h5>Repeat new master password</h5>
                <v-text-field
                  v-model="form.newMasterPassword.repeatValue"
                  :error-messages="form.newMasterPassword.repeatErrors"
                  type="password"
                  label="Master password"
                  required
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-spacer />
              <v-flex
                xs12
                class="text-xs-right"
              >
                <v-btn
                  outline
                  color="#FF9900"
                  @click="_storeMasterPassword({
                    master_password: form.masterPassword.value,
                    password: form.newMasterPassword.value,
                    repeat_password: form.newMasterPassword.repeatValue
                  })"
                >
                  SAVE
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog
      v-if="importLink"
      v-model="importLinkDialog"
      width="400"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Import link URL
        </v-card-title>
        <v-card-text>{{ importLink.url }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            @click="importLinkDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { setTimeout } from 'timers';

export default {
  name: 'ApplicationClient',
  props: [],
  data: () => ({
    form: {
      name: { value: '', errors: [], messages: [] },
      apiKey: { value: '', errors: [], messages: [] },
      masterPassword: { value: '', errors: [], messages: [] },
      newMasterPassword: {
        value: '',
        repeatValue: '',
        errors: [],
        repeatErrors: [],
        messages: [],
      },
      linkMasterPassword: { value: '', errors: [], messages: [] },
    },
    importLink: '',
    importLinkDialog: false,
  }),
  computed: {
    ...mapGetters(['client']),
  },
  async mounted() {
    await this.getClient();
  },
  methods: {
    ...mapActions([
      'getClient',
      'storeName',
      'generateImportLink',
      'storeMasterPassword',
      'generateApiKey',
    ]),
    async _storeName(data) {
      try {
        await this.storeName(data);
        this.form.name.messages.push('Saved successfully.');
        setTimeout(() => {
          this.form.name.messages = [];
        }, 6000);
      } catch (error) {
        this.form.name.errors = error.message;
      }
    },
    async _generateImportLink(data) {
      try {
        const importLink = await this.generateImportLink(data);
        if (importLink) {
          this.form.linkMasterPassword.value = '';
          this.importLink = importLink;
          this.importLinkDialog = true;
          this.form.linkMasterPassword.messages.push(
            'Import link genrated successfully.',
          );
        }

        setTimeout(() => {
          this.form.linkMasterPassword.messages = [];
        }, 6000);
      } catch (error) {
        this.form.linkMasterPassword.errors = error.message;
      }
    },
    async _generateApiKey() {
      try {
        await this.generateApiKey();
        this.form.apiKey.messages.push('API Key generated successfully.');
        setTimeout(() => {
          this.form.apiKey.messages = [];
        }, 6000);
      } catch (error) {
        this.form.apiKey.errors = error.message;
      }
    },
    async _storeMasterPassword(data) {
      await this.storeMasterPassword(data)
        .then(() => {
          this.form.masterPassword.value = '';
          this.form.newMasterPassword.value = '';
          this.form.newMasterPassword.repeatValue = '';

          this.form.masterPassword.messages.push(
            'Mater password saved successfully.',
          );
          setTimeout(() => {
            this.form.masterPassword.messages = [];
          }, 6000);
        })
        .catch((error) => {
          this.form.masterPassword.errors =
            error.response.data.errors.master_password;
          this.form.newMasterPassword.errors =
            error.response.data.errors.password;
          this.form.newMasterPassword.repeatErrors =
            error.response.data.errors.repeat_password;
        });
    },
    validateNewMasterPassword(value, repeatValue) {
      if (value === repeatValue) {
        return repeatValue;
      }
      this.form.masterPassword.errors.push('Passwords do not match.');

      return null;
    },
  },
};
</script>

<style lang='scss' scoped>
.container {
  padding: 16px;
  padding-bottom: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/applicationClient/applicationClientSettings.vue